import React, { useState } from 'react';
import styles from './User.module.css';
import GenericIconButton from '../GenericComponents/GenericIconButton';

interface ForgotPasswordProps {
    onMessage: (message: string) => void;
    onClose: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onClose, onMessage }) => {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [localEmail, setLocalEmail] = useState({
        email: ''
    });

    const handleChange = (field: 'realname' | 'email' | 'password', value: string) => {
        setLocalEmail(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_USERMANAGEMENT_URL}?action=forgotpassword`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: localEmail.email,
                }),
            });

            if (!response.ok) {
                throw new Error("Erreur " + response.statusText);
            }

            const result = await response.text();
            if (result === "Password sent") {
                onMessage("Mot de passe envoyé")
                onClose();
            } else if (result === "Password sent !") {
                onMessage("Si votre email existe, vous allez recevoir un nouveau mot de passe")
                onClose();
            } else {
                throw new Error(result || "Erreur");
            }
        } catch (err) {
            console.error("Erreur email", err);
            setError("Erreur email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.popupoverlay}>
            <div className={styles.popup} role="dialog" aria-modal="true" aria-labelledby="update-account-title">
                <div className={styles.header}>
                    <h2 id="update-account-title">Saisissez votre e-mail pour recevoir un nouveau mot de passe</h2>
                    <GenericIconButton
                        icon='light/times.svg'
                        width='18px'
                        height='18px'
                        onClick={onClose}
                        aria-label="Close"
                    />
                </div>
                <div className={styles.main}>
                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        <div className={styles.formGroup}>
                            <label htmlFor="email">E-mail</label>
                            <input
                                type="text"
                                id="email"
                                value={localEmail.email}
                                required
                                onChange={e => handleChange('email', e.target.value)}
                            />
                        </div>
                        {error && (
                            <div className={styles.errorMessage}>
                                {error}
                            </div>
                        )}
                        <div className={styles.footer}>
                            <button
                                className={`${styles.loginSubmitButton}`}
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Envoyé" : "Envoyer"}
                            </button>
                            <button
                                className={`${styles.cancelButton}`}
                                type="button"
                                onClick={onClose}
                            >
                                Annuler
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
